import axios from "axios";

const useApi = () => {
  const api = axios.create({
    baseURL: process.env.NEXT_PUBLIC_CMS_URL + "/api",
    timeout: 30000,
  });

  const GET = async (path, config = {}) => {
    try {
      const response = await api.get(path, config);
      const data = response.data;
      return data;
    } catch (error) {
      const serverError = error?.response?.data || error;
      throw new Error(serverError.message);
    }
  };

  const POST = async (path, body = {}) => {
    try {
      const response = await api.post(path, body);
      const data = response.data;
      return data;
    } catch (error) {
      const serverError = error?.response?.data || error;
      throw new Error(serverError.message);
    }
  };

  const PUT = async (path, body) => {
    try {
      const response = await api.put(path, body);
      const data = response.data;
      return data;
    } catch (error) {
      const serverError = error?.response?.data || error;
      throw new Error(serverError.message);
    }
  };

  const DELETE = async path => {
    try {
      const response = await api.delete(path);
      const data = response.data;
      return data;
    } catch (error) {
      const serverError = error?.response?.data || error;
      throw new Error(serverError.message);
    }
  };

  return { GET, POST, DELETE, PUT };
};

export default useApi;
